import React from 'react';
import CheckoutHeader from './style';

export default props => <CheckoutHeader {...props} />;
